import React from 'react'
import styled, { keyframes } from 'styled-components'
import { hexToRgbA } from '../../utils/helper'

const shimmer = keyframes`
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
`

const SkeletonBox = styled.div`
  background: linear-gradient(
    90deg,
    ${props => hexToRgbA(props.theme.color.borderLight, 0.3)} 25%,
    ${props => hexToRgbA(props.theme.color.borderLight, 0.5)} 50%,
    ${props => hexToRgbA(props.theme.color.borderLight, 0.3)} 75%
  );
  background-size: 200% 100%;
  animation: ${shimmer} 1.5s ease-in-out infinite;
  border-radius: ${props => props.borderRadius || '4px'};
  width: ${props => props.width || '100%'};
  height: ${props => props.height || '16px'};
  margin: ${props => props.margin || '0'};
`

const Skeleton = ({ width, height, borderRadius, margin, style }) => {
  return (
    <SkeletonBox
      width={width}
      height={height}
      borderRadius={borderRadius}
      margin={margin}
      style={style}
    />
  )
}

export default Skeleton
